import useSWR from "swr";
// @ts-expect-error pure js
import useAuthenticatedAxios from "./use-authenticated-axios";
// @ts-expect-error pure js
import useAuth from "./use-auth.js";
import type { StatsRentabilite } from "../models/statsRentabilite";

const ROOT_URL = "/stats/rentabilite";

export default function useStatsRentabilite(
  debut: string | undefined,
  fin: string,
  property_ids: number[],
  profile_bailleur_ids: number[],
) {
  const axios = useAuthenticatedAxios();
  const { userId } = useAuth();
  const {
    data: rentabilite,
    error,
    isLoading,
  } = useSWR<StatsRentabilite>(
    {
      url: ROOT_URL,
      filter: {
        debut,
        fin,
        property_ids,
        profile_bailleur_ids,
      },
      userId,
    },
    ({ url, filter }: { url: string; filter: object }) => {
      return axios
        .post(url, filter)
        .then((res: { data: StatsRentabilite }) => res.data);
    },
  );

  return { rentabilite, error, isLoading };
}
